import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';

import { BankInstitutionListComponent } from './bankinstitutionlist/bankinstitution-list.component';
import { BankInstitutionComponent } from './bankinstitution/bankinstitution.component';

import { BankInstitution } from 'app/shared/models/bank-institution.model';

@Component({
    selector: 'app-bankinstitutions',
    templateUrl: './bankinstitutions.component.html'
})
/**
 * Component for Bank Institutions.
 */
export class BankInstitutionsComponent {
    dialogRef: MdDialogRef<any>;
    selectedData: Object;

    @ViewChild('bankinstitutions') bankInstitutionsList: BankInstitutionListComponent;

    constructor(
        private dialog: MdDialog,
        private viewContainerRef: ViewContainerRef,
        private warmUpService: WarmUpService,
        private snackBarService: SnackBarService
    ) { }

    openAddBankInstitutionDialog() {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(BankInstitutionComponent, config);
        this.dialogRef.componentInstance.action = 'Add';
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                this.updateBankInstitutionsListAfterAdd(result);
            }
        });
    }

    updateBankInstitutionsListAfterAdd(formResponse: BankInstitution) {
        this.bankInstitutionsList.updateBankInstitutionsList();
    }
}



// WEBPACK FOOTER //
// ./src/app/finance/bankinstitutions/bankinstitutions.component.ts